<!--
 * @Description  : 详情页面 订单信息流 竖状流转
-->

<template minapp='mpx' xlang='wxml'>
  <view class="es-card" wx:if="{{refactorList != null }}" wx:style="{{customStyle}}">
    <slot name="title"/>
    <view class="es-card__divider"></view>
    <view class="es-card__tips" wx:if="{{tips != null && tips != ''}}">{{tips}}</view>
    <view class="es-card__content">
      <view wx:for="{{refactorList}}" wx:key="index">
        <view class="es-card__item">
        <view class="es-card__item-time">
          <es-icon name="{{item.iconName}}" color="{{item.color}}" size="18px"></es-icon>
          <view class="es-card__item-line" wx:if="{{refactorList.length - 1 !=index}}"></view>
        </view>
        <view class="es-card__item-right">
           <view class="es-card__item-top" wx:style="{{currentFilledIndex ===index ? 'color:#000000' : '' }}">{{item.name || item.record_text}}</view>
           <view class="es-card__item-bottom" >{{item.value || item.record_time}}</view>
        </view>
        </view>
      </view>
    </view>
  </view>

</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { getFinalPrice } from '../../utils/money'

  createComponent({
    props: {
      currOrder: Object,
      tips: String,
      list: [],
      upSequence: {
        type: Boolean,
        value: true
      },
      customStyle: {
        type: Object,
        value: {}
      }
    },
    data: {},
    computed: {
      currentFilledIndex() {
        return this.upSequence ? this.list.length - 1 : 0
      },
      refactorList() {
        return this.list?.map((item, index) => {
          item.color =
            item.is_success == 0 || item.record_status == 3
              ? '#E12E2E'
              : this.currentFilledIndex == index
              ? '#438FFF'
              : '#A3A3A3'

          //record_status	int	操作状态(0-默认灰色，1-待审批，2-审批通过，3-审批驳回)
          item.iconName =
            item.is_success == 0 || item.record_status == 3
              ? 'close-circle-filled'
              : item.record_status == 1
              ? 'more-circle-filled'
              : 'check-circle-filled'
          // item.iconName =
          //   item.is_success == 0 ? 'close-circle-filled' : 'check-circle-filled'
          return item
        })
      }
    },
    methods: {}
  })
</script>
<style scoped lang="stylus" src='./style.styl'></style>
<script name='json'>
  module.exports = {
    component: true
  }
</script>